// Generated by LispyScript v1.0.0
var fetch = function() {
    return new Promise(function(resolve,reject) {
        return setTimeout(function() {
            return (((Math.random() - 0.5) > 0) ?
                resolve({
                    message: "Hello, World!"
                }) :
                reject());
        },2250);
    });
};
var app = {
    data: function() {
        return {
            count: 0,
            interval: null,
            loading: true,
            message: "Loading."
        };
    },
    mounted: function() {
        var vm = this;
        this.interval = setInterval(this.handleInterval,750);
        var request = fetch();
        return request.then(function(data) {
            vm.loading = false;
            vm.message = data.message;
        },request.catch(function() {
            vm.loading = false;
            vm.message = "Something went wrong.";
        }));
    },
    methods: {
        handleInterval: function() {
            var vm = this;
            return (this.loading ?
                (function() {
                    vm.message = (vm.message + ".");
                })() :
                (function() {
                    clearInterval(vm.interval);
                    vm.interval = null;
                })());
        },
        increment: function() {
            this.count = (this.count + 1);
        },
        decrement: function() {
            this.count = (this.count - 1);
        }
    },
    template: "\n    <div>\n      <h1 class='header'>LispyScript demo app (with Vue!)</h1>\n      <h2>{{ message }}</h2>\n      <p>This test \"request\" will fail 50% of the time.</p>\n      <button @click='decrement'>decrement</button>\n      <button @click='increment'>increment</button>\n      <div class='count'>Count: {{ this.count }}</div>\n    </div>"
};
module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./src/app.ls
// module id = 2
// module chunks = 0